import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface DocumentosDesplazamientosPayload {
  codigo: string;
  version: number;
  fecha_designacion: string;
  fecha_vencimiento: string;
  motivo_creacion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface DocumentosDesplazamientos {
  id?: number;
  codigo: string;
  version: number;
  fecha_designacion: string;
  fecha_vencimiento: string;
  motivo_creacion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

/**
 * 🔹 Respuesta genérica
 */
export interface DocumentosDesplazamientosResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class DocumentosDesplazamientosService {
  private readonly apiUrl = `${environment.apiUrl}/api/documentos_desplazamientos`;

  constructor(private http: HttpClient) {}

  // Obtener todos los registros
  getAll(): Observable<DocumentosDesplazamientos[]> {
    return this.http.get<DocumentosDesplazamientos[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  // Obtener por ID
  getById(id: number): Observable<DocumentosDesplazamientos> {
    return this.http.get<DocumentosDesplazamientos>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Crear registro
  create(
    payload: DocumentosDesplazamientosPayload
  ): Observable<DocumentosDesplazamientosResponse> {
    return this.http.post<DocumentosDesplazamientosResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Actualizar registro
  update(
    id: number,
    payload: Partial<DocumentosDesplazamientosPayload>
  ): Observable<DocumentosDesplazamientosResponse> {
    return this.http.put<DocumentosDesplazamientosResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Eliminar registro
  Inactive(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Inactivar registro
  inactivar(id: number): Observable<DocumentosDesplazamientosResponse> {
    return this.http.put<DocumentosDesplazamientosResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  // Activar registro
  activar(id: number): Observable<DocumentosDesplazamientosResponse> {
    return this.http.put<DocumentosDesplazamientosResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}